import { trackDatadogError } from '@/shared/external/datadog'

import { isDev } from '../constants'

type TTokenGetter = () => string | null | undefined

const MISSING_GETTER_MESSAGE =
  '파트너스 토큰 getter가 등록되지 않아, 파트너스 API를 인증 없이 호출합니다. usePartnersAuthStore를 로드했는지 확인해 주세요.'

let tokenGetter: TTokenGetter | null = null

export const setPartnersAccessTokenGetter = (getter: TTokenGetter): void => {
  tokenGetter = getter
}

export const getPartnersAccessToken = (): string | null | undefined => {
  if (tokenGetter) return tokenGetter()

  trackDatadogError(
    Object.assign(new Error(MISSING_GETTER_MESSAGE), {
      dd_fingerprint: 'partnersAuthToken:missing-getter',
    }),
    { source: 'partnersAuthToken' }
  )

  if (isDev) {
    console.warn(MISSING_GETTER_MESSAGE)
  }

  return undefined
}
